/**
 * ogPageImages.ts - OG image CDN URLs for product pages and city pages
 * Auto-generated. Do not edit manually.
 */

export const ogPageImages: Record<string, string> = {
  "boyta": "/manus-storage/og-page-boyta_13eb6c23.png",
  "bygglov": "/manus-storage/og-page-bygglov_6417a84c.png",
  "checklista": "/manus-storage/og-page-checklista_885dedbf.png",
  "fragor": "/manus-storage/og-page-fragor_8b085aa3.png",
  "glaspartier": "/manus-storage/og-page-glaspartier_719da2d0.png",
  "goteborg": "/manus-storage/og-page-goteborg_00340719.png",
  "grund": "/manus-storage/og-page-grund_75de333a.png",
  "helsingborg": "/manus-storage/og-page-helsingborg_99921ab3.png",
  "hem": "/manus-storage/og-page-hem_694a00fc.png",
  "inspiration": "/manus-storage/og-page-inspiration_c9927dd8.png",
  "kondens": "/manus-storage/og-page-kondens_fc2362ba.png",
  "linkoping": "/manus-storage/og-page-linkoping_88734d8c.png",
  "malmo": "/manus-storage/og-page-malmo_58d38c73.png",
  "oisolerat": "/manus-storage/og-page-oisolerat_a9337541.png",
  "orebro": "/manus-storage/og-page-orebro_3f3d02f9.png",
  "pris": "/manus-storage/og-page-pris_88426854.png",
  "referenser": "/manus-storage/og-page-referenser_cd00a345.png",
  "stockholm": "/manus-storage/og-page-stockholm_5909036c.png",
  "storlek": "/manus-storage/og-page-storlek_b50324df.png",
  "tak": "/manus-storage/og-page-tak_55b9e8a9.png",
  "uppsala": "/manus-storage/og-page-uppsala_c6ae1e30.png",
  "uppvarmning": "/manus-storage/og-page-uppvarmning_9b5495a2.png",
  "uterum-vs-orangeri": "/manus-storage/og-page-uterum-vs-orangeri_04e20ead.png",
  "uterum": "/manus-storage/og-page-uterum_cdd04882.png",
  "vasteras": "/manus-storage/og-page-vasteras_d11c3106.png",
  "vinterbonat": "/manus-storage/og-page-vinterbonat_575d3bce.png",
  "vara-paket": "/manus-storage/og-vara-paket_6e3ddbc4.png",
  "fabrik": "/manus-storage/og-fabrik_9d0177a2.png",
  "visualisera": "/manus-storage/og-page-visualisera_d3e0279b.png",
  "sommar-paket": "/manus-storage/og-sommar-paket-S2wJXvS9GjBZ2tEuy32oHF.png",
  "forlangd-sommar-paket": "/manus-storage/og-forlangd-sommar-paket-E5Krtf5jNjCMHWoTFgpwMC.png",
  "var-host-paket": "/manus-storage/og-var-host-paket-iWEfTiNkvkiuoiLgEaqR4f.png",
  "vinterbonat-paket": "/manus-storage/og-vinterbonat-paket-7s89SvrWf8RymyNYRt5ccw.png",
  "boyta-paket": "/manus-storage/og-boyta-paket-QUEctNFmMkpPetko8MJvuv.png",
};

export function getPageOgImage(slug: string): string | undefined {
  return ogPageImages[slug];
}
